import { useEffect, useState } from 'react'
import { AvatarImage } from '@/components/ui/avatar'
import { userPhoto } from '@/auth/graph'

/** Profile photo for a directory user; renders nothing (so the initials show) when there is none. */
export function UserPhoto({ id }: { id: string }) {
    const [src, setSrc] = useState<string | null>(null)
    useEffect(() => {
        let live = true
        void userPhoto(id).then((u) => { if (live) setSrc(u) })
        return () => { live = false }
    }, [id])
    return src ? <AvatarImage src={src} alt="" /> : null
}
